import React, { useState } from "react";
import { FaRegCalendarAlt, FaClock, FaRegCalendarCheck } from "react-icons/fa";
import ApplicationModal from "./ApplicationModal";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";

const ProgramCohorts = ({ course }) => {
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const { loggedIn } = useSelector((state) => state.authentication || {});

    // Calculate dynamic batch schedules relative to today
    const nextMonth = moment().add(1, "month");
    const inductionDate = nextMonth.clone().date(11);
    const classesStartDate = nextMonth.clone().date(15);
    
    // Default duration is 4 months if not specfied
    const classesEndDate = classesStartDate.clone().add(4, "months");
    
    const cohortTitle = `${course?.CourseName || "IITM"} ${nextMonth.format("MMM YYYY")} Cohort 1`;

    const cohortData = {
        cohortTitle: cohortTitle,
        badge: "Limited Seats Left",
        schedule: [
            {
                id: 1,
                title: "Program Induction",
                date: inductionDate.format("DD MMM, YYYY"),
                time: "19:00 IST",
                batchType: null
            },
            {
                id: 2,
                title: "Regular Classes",
                date: `${classesStartDate.format("DD MMM, YYYY")} - ${classesEndDate.format("DD MMM, YYYY")}`,
                time: "19:00 - 22:00 IST",
                batchType: ["Weekend", "Sa", "Su"]
            }
        ]
    };

    const handleApplyClick = () => {
        if (loggedIn) {
            setModalOpen(true);
        } else {
            navigate("/register");
        }
    };

    return (
        <div className="p-6 max-w-7xl mx-auto text-left">
            <h2 className="text-3xl font-bold text-gray-900">Program Cohorts</h2>
            <h3 className="text-lg text-gray-500 mt-2 font-bold">Next Batch Details</h3>

            <div className="mt-6 border border-gray-150 rounded-2xl overflow-hidden shadow-xs bg-white">
                <div className="flex flex-wrap items-center bg-blue-50/60 p-5 gap-4 justify-between border-b border-gray-100">
                    <h4 className="text-lg font-bold text-gray-900">
                        {cohortData.cohortTitle}
                    </h4>
                    <span className="bg-amber-400 text-gray-900 text-xs font-black uppercase tracking-wider px-3 py-1.5 rounded-lg shadow-2xs">
                        {cohortData.badge}
                    </span>
                </div>

                <div className="overflow-x-auto px-6 py-4">
                    <table className="w-full border-collapse">
                        <thead className="text-gray-400 text-xs font-black uppercase tracking-wider">
                            <tr className="border-b border-gray-100">
                                <th className="px-4 py-3 text-left w-12">#</th>
                                <th className="px-4 py-3 text-left">
                                    <span className="flex items-center gap-1.5"><FaRegCalendarAlt /> Date</span>
                                </th>
                                <th className="px-4 py-3 text-left">
                                    <span className="flex items-center gap-1.5"><FaClock /> Time</span>
                                </th>
                                <th className="px-4 py-3 text-left">
                                    <span className="flex items-center gap-1.5"><FaRegCalendarCheck /> Batch Type</span>
                                </th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-100">
                            {cohortData.schedule.map((item) => (
                                <tr key={item.id} className="text-gray-800 text-sm font-semibold hover:bg-gray-50/50 transition-colors">
                                    <td className="px-4 py-4 font-bold text-gray-400">
                                        {item.id}
                                    </td>
                                    <td className="px-4 py-4">
                                        <div className="text-gray-900 font-bold">{item.title}</div>
                                        <div className="text-gray-500 text-xs mt-0.5">{item.date}</div>
                                    </td>
                                    <td className="px-4 py-4 text-gray-600">{item.time}</td>
                                    <td className="px-4 py-4">
                                        {item.batchType ? (
                                            <div className="flex items-center gap-2">
                                                <span className="text-gray-700 text-xs">{item.batchType[0]}</span>
                                                {item.batchType.slice(1).map((day, index) => (
                                                    <span key={index} className="bg-gray-100 text-gray-650 px-2 py-0.5 rounded-md text-[10px] font-black uppercase">
                                                        {day}
                                                    </span>
                                                ))}
                                            </div>
                                        ) : (
                                            <span className="text-gray-400 font-medium">-</span>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="p-6 bg-gray-50/50 border-t border-gray-100 flex justify-end">
                    <button 
                        onClick={handleApplyClick}
                        className="btn-primary-custom !py-3 !px-8 text-sm"
                    >
                        Apply Now
                    </button>
                </div>
            </div>
            <ApplicationModal 
                isOpen={modalOpen} 
                onClose={() => setModalOpen(false)} 
                courseId={course?.ID} 
                CourseName={course?.CourseName} 
            />
        </div>
    );
};

export default ProgramCohorts;
